import moment from 'moment';

const nInt = (number, nullValue = 0) => {
  let formatNumber = 0;
  number = parseFloat(number);
  if (!!number && !isNaN(number)) {
    formatNumber = new Intl.NumberFormat('es-PE').format(parseInt(number));
  }
  if (formatNumber === 0) {
    return nullValue;
  }

  return formatNumber;
};

const currency = (number, xls = undefined) => {
  let formatNumber = 0;
  if (!!number && !isNaN(number)) {
    formatNumber = new Intl.NumberFormat('es-PE', {
      style: 'currency',
      currency: 'PEN'
    }).format(number);
  }

  return xls ? (formatNumber || '0').replace(/\s/g, '') : formatNumber;
};

const nCurrency = (number, nullValue = undefined) => {
  let formatNumber = 0;
  if (!!number && !isNaN(number)) {
    number = parseFloat(number);
    formatNumber = new Intl.NumberFormat('es-PE', {
      style: 'currency',
      currency: 'PEN'
    }).format(number);
  }

  if (number === 0 && nullValue !== undefined) {
    return nullValue;
  }
  return formatNumber;
};

const nDecimal = (number) => {
  let formatNumber = 0;
  if (!!number && !isNaN(number)) {
    formatNumber = new Intl.NumberFormat('es-PE', {
      style: 'decimal',
      maximumFractionDigits: 2
    }).format(number);
  }

  return formatNumber;
};

const nPercent = (number, nullValue = undefined) => {
  let formatNumber = 0;
  if (!!number && !isNaN(number)) {
    formatNumber = parseFloat(number);
  }

  if (formatNumber === 0) {
    if (nullValue !== undefined) {
      return nullValue;
    }
    return formatNumber;
  }

  return formatNumber.toFixed(2) + '%';
};

const onlyInteger = (e) => {
  let key = window.event ? e.which : e.keyCode;
  if (key < 48 || key > 57) return e.preventDefault();
};

const roundMony = (value) => {
  return Math.round((value || 0) * 100) / 100;
};

const onlyMoney = (e) => {
  const maxDecimal = 2;
  let key = window.event ? e.which : e.keyCode;
  // solo números y puntos
  if ((key < 48 || key > 57) && key !== 46) return e.preventDefault();
  //no dejar ingresar más de un punto
  if (key === 46 && e.target.value.includes('.')) return e.preventDefault();

  //TODO code para limitacion de decimales (incompleto)
  /* const str = e.target.value;
  if (str.length > 0 && e.target.value.includes('.')) {
    const decimal = str.substring(str.indexOf('.'), str.length);
    const longDecimal = str.substring(str.indexOf('.'), str.length).length - 1;
    const valueInteger = str.substring(0, str.indexOf('.'));
    const cutDecimal = decimal.substring(0, 1 + maxDecimal);
    if (longDecimal >= maxDecimal - 1) {
      return (e.target.value = `${valueInteger}${window.event.key}${cutDecimal}`);
    }
  } */
};

/**
 *
 * @param {*date fecha a formatear } date
 * @param {*string formato de fecha (FH = fecha y hora), (F = solo fecha), (H = solo hora) } type
 * @returns date
 */
const formatDate = (date, type = 'FH') => {
  if (type === 'F') {
    type = 'DD-MM-YYYY';
  } else if (type === 'H') {
    type = 'HH:mm:ss';
  } else {
    type = 'DD-MM-YYYY HH:mm:ss';
  }

  return date ? moment(date).format(type) : '--/--/--';
};

function nthIndexOf(string, searchElement, n, fromElement) {
  n = n || 0;
  fromElement = fromElement || 0;
  while (n > 0) {
    fromElement = string.indexOf(searchElement, fromElement);
    if (fromElement < 0) {
      return -1;
    }
    --n;
    ++fromElement;
  }
  return fromElement - 1;
}

export {
  nInt,
  currency,
  nCurrency,
  nDecimal,
  nPercent,
  onlyInteger,
  roundMony,
  onlyMoney,
  formatDate,
  nthIndexOf,
};
